/* eslint-disable jira/filename-case */
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import { getCmdbRestBaseUrl } from './getCmdbRestBaseUrl.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/data-manager/token/${type}?label=${label}&duration=${duration}
 */
export const getDataManagerGenerateContainerTokenUrl = (
	workspaceId: WorkspaceId,
	label: string,
	type: string,
	duration: string,
): string =>
	`${getCmdbRestBaseUrl(workspaceId)}/data-manager/token/${type}?label=${label}&duration=${duration}`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/data-manager/token/${tokenId}
 */
export const delDataManagerContainerTokenUrl = (
	workspaceId: WorkspaceId,
	tokenID: string,
): string => `${getCmdbRestBaseUrl(workspaceId)}/data-manager/token/${tokenID}`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/data-manager/token
 */
export const getDataManagerFetchContainerTokenUrl = (workspaceId: WorkspaceId): string =>
	`${getCmdbRestBaseUrl(workspaceId)}/data-manager/token`;

/**
 * /gateway/api/jsm/data-manager/workspace/${workspaceId}/app/config/sync/provisioningstatus
 */
export const getDataManagerProvisioningStatusUrl = (workspaceId: WorkspaceId): string =>
	`${getAirtrackAppRestBaseUrl(workspaceId)}/config/sync/provisioningstatus`;

const getAirtrackAppRestBaseUrl = (workspaceId: WorkspaceId) =>
	`/gateway/api/jsm/data-manager/workspace/${workspaceId}/app`;
